import { isEmpty } from "lodash";
import { LOCAL_HS_CODE_CLASSIFICATION_URL } from "./const";

export function getHSCodeClassificationUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const HS_CODE_CLASSIFICATION_URL = !!import.meta.env.VITE_HS_CODE_CLASSIFICATION_URL && import.meta.env.VITE_HS_CODE_CLASSIFICATION_URL !== "" ? import.meta.env.VITE_HS_CODE_CLASSIFICATION_URL : LOCAL_HS_CODE_CLASSIFICATION_URL;
  if (!isEmpty(REACT_ENV)) {
    return HS_CODE_CLASSIFICATION_URL;
  } else {
    return LOCAL_HS_CODE_CLASSIFICATION_URL;
  }
}
